import * as types from './mutation-types'

const mutations = {
  [types.SET_USER_INFO](state,userInfo){
    state.userInfo = userInfo
  },
  [types.SET_CART_NUM](state,shopCartNum){
    state.shopCartNum = shopCartNum
  },
  [types.SET_SHOW_SEARCH](state,showSearch){
    state.showSearch = showSearch
  },
  [types.SET_USER_REGISTERID](state,registerId){
    state.registerId = registerId
  },
  [types.SET_LINKSRC](state,linkSrc){
    state.linkSrc = linkSrc
  },
  [types.SET_AVATAR](state,avatar){
    state.avatar = avatar
  },
  [types.SET_ENTERTIME](state,avatar){
    state.enterTime = enterTime
  },
  [types.SET_LEAVETIME](state,avatar){
    state.leaveTime = leaveTime
  },
  [types.SET_KEYWORD](state, keyword){
    state.keyword = keyword
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js